import Link from "../../../components/common/LinkButton";
import { useDispatch } from "react-redux";
import { AppDispatch } from "store/store";
import { setSelectedIndex } from "../../../store/slices/DocsSlice";
import { DocsTab } from "../../../shared/enums/DocsTabEnum";

export default function QuickStartDescription() {
  const dispatch = useDispatch<AppDispatch>();

  const handleClick = () => {
    dispatch(setSelectedIndex(DocsTab.DevelopersSection));
  };

  return (
    <div className="font-inter text-18px leading-28px">
      <div>
        Welcome to the timePhasing quick start guide. The aim of this guide is
        to give you a basic understanding of the various features within time
        phasing, as well as provide instruction on how to create your first API
        request.
      </div>
      <div className="mt-8 mr-4">
        We recommend reading in its entirety. If you need more in-depth
        knowledge of our API, visit our
        <Link className="text-primaryRed mx-1 font-bold text-base" onClick={handleClick}>
          Developers Section
        </Link>
        page.
      </div>
    </div>
  );
}
